import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import { SmoothScroll } from "./components/SmoothScroll";
import Home from "./pages/Home";
import Category from "./pages/Category";
import Article from "./pages/Article";
import Search from "./pages/Search";
import FromTheWebPage from "./pages/FromTheWeb";
import AdminLogin from "./pages/admin/AdminLogin";
import AdminList from "./pages/admin/AdminList";
import AdminEditor from "./pages/admin/AdminEditor";
import AdminTeam from "./pages/admin/AdminTeam";
import AdminBanner from "./pages/admin/AdminBanner";
import AdminImport from "./pages/admin/AdminImport";
import AdminIssue from "./pages/admin/AdminIssue";
import { AuthProvider, Protected } from "./lib/auth";
import { HelmetProvider } from "react-helmet-async";
import { Seo } from "./components/Seo";
import { DownloadPage, PaymentCancel, PaymentSuccess } from "./pages/Shop";

const PublicFooter = () => (useLocation().pathname.startsWith("/admin") ? <Seo title="Newsroom | YOUTH" noindex /> : <Footer />);

function App() {
  return (
    <HelmetProvider>
    <div className="grain min-h-screen bg-cream text-ink">
      <BrowserRouter>
        <AuthProvider>
        <SmoothScroll />
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/category/:cat" element={<Category />} />
          <Route path="/article/:slug" element={<Article />} />
          <Route path="/search" element={<Search />} />
          <Route path="/from-the-web" element={<FromTheWebPage />} />
          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/payment/cancel" element={<PaymentCancel />} />
          <Route path="/download/:token" element={<DownloadPage />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<Protected><AdminList /></Protected>} />
          <Route path="/admin/new" element={<Protected><AdminEditor /></Protected>} />
          <Route path="/admin/edit/:slug" element={<Protected><AdminEditor /></Protected>} />
          <Route path="/admin/team" element={<Protected><AdminTeam /></Protected>} />
          <Route path="/admin/banner" element={<Protected><AdminBanner /></Protected>} />
          <Route path="/admin/import" element={<Protected><AdminImport /></Protected>} />
          <Route path="/admin/issue" element={<Protected><AdminIssue /></Protected>} />
          <Route path="/admin/preview/:slug" element={<Protected><Article preview /></Protected>} />
        </Routes>
        <PublicFooter />
        <Toaster position="bottom-center" />
        </AuthProvider>
      </BrowserRouter>
    </div>
    </HelmetProvider>
  );
}

export default App;
